/**
 * Make sure the phone number starts with the provided international prefix.
 */
export function internationalizePhoneNumber(number: string, prefix: string): string {
    /**
     * The beginning of the number matches the prefix.
     *
     * When the provided string isn’t as long as the prefix, it only compares
     * with the prefix until the end of the number (hence `substring`).
     */
    if (number.startsWith(prefix.substr(0, number.length))) {
        return number;
    }

    /**
     * Replace numbers starting with `00{prefix}` by `+{prefix}`.
     * May happens on number autocompletion or pasting.
     */
    const zeroPaddedPrefix = prefix.replace("+", "00");

    if (number.startsWith(zeroPaddedPrefix)) {
        return number.replace(zeroPaddedPrefix, prefix);
    }

    /**
     * Replace numbers starting with `0` by the prefix.
     * May happens on number autocompletion or pasting.
     */
    if (number[0] == "0") {
        return prefix + number.substring(1);
    }

    return prefix + number;
}
